module.exports = __webpack_public_path__ + "img/product8.e11cf28b.png";